import _ from 'underscore';
import { ProjectionGridBaseColumn, helpers } from '@bingads-webui/projection-grid-base-column';

const regexPerfMetrics = /^(Performance)?Metrics\//;
const regexPhonePerfMetrics = /^PhonePerformanceMetrics\//;

function propertyMatch(regex, property) {
  const keyPath = _.isString(property) ? property : property.key;
  return _.isString(keyPath) && keyPath.match(regex);
}

/**
 * Determines if the input is a PerformanceMetrics property.
 *
 * @param {String} property the property to query
 * @returns {Boolean} whether the property is a PerformanceMetrics or not.
 */
export const isPerformanceMetrics = _.partial(propertyMatch, regexPerfMetrics);

/**
 * Determines if the input is a PhonePerformanceMetrics property.
 *
 * @param {String} property the property to query
 * @returns {Boolean} whether the property is a PhonePerformanceMetrics or not.
 */
export const isPhonePerformanceMetrics = _.partial(propertyMatch, regexPhonePerfMetrics);

export class CampaignuiBaseColumn extends ProjectionGridBaseColumn {
  get colClasses() {
    let colClasses = super.colClasses;

    if (isPerformanceMetrics(this.config.property)) {
      colClasses = helpers.mergeClasses(colClasses, [
        'performance-metrics',
        `performance-metrics-${this.name}`,
      ]);
    } else if (isPhonePerformanceMetrics(this.config.property)) {
      colClasses = helpers.mergeClasses(colClasses, [
        'phone-performance-metrics',
        `phone-performance-metrics-${this.name}`,
      ]);
    }

    return colClasses;
  }
}
